import { metrics } from '@news-mono/component-library'
import { TogglesReduxState, GetRouteAdTargeting } from '@news-mono/web-common'
import { layout } from '../../App.routing'

export const getShortsVideoCarouselSegment = (
    toggles: TogglesReduxState,
    getAdTargeting: GetRouteAdTargeting,
) => {
    const isVerticalVideoCarouselEnabled = Boolean(
        toggles['vertical-videos-on-homepage'],
    )

    if (!isVerticalVideoCarouselEnabled) {
        return []
    }

    const isVerticalVideoAdsEnabled = Boolean(toggles['vertical-video-ads'])

    const { adUnitPath } = getAdTargeting('vertical-video', 'default', 'home')

    return [
        layout.nestedComposition({
            type: 'thor',
            props: {
                horizontalGutters: false,
                verticalGutters: 'lg',
                containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
            },
            contentAreas: {
                main: [
                    layout.component({
                        type: 'section-header',
                        props: {
                            heading: 'Shorts',
                            isFullWidth: true,
                            hasBottomMargin: true,
                        },
                    }),
                    layout.component({
                        type: 'vertical-video-hub',
                        props: {
                            adUnitPath,
                            showAds: isVerticalVideoAdsEnabled,
                            lazyLoad: true,
                            dataDefinitionArgs: {
                                type: 'video-listing',
                                topics: [],
                                paging: {
                                    pageSize: 15,
                                    page: 1,
                                },
                                orientation: 'vertical',
                            },
                        },
                    }),
                ],
            },
        }),
    ]
}
